import {
  GET_ADS_SUCCESS,
  GET_ADS_FAILURE,
  GET_AD_SUCCESS,
  GET_AD_FAILURE,
  ADD_AD_SUCCESS,
  ADD_AD_FAILURE,
  EDIT_AD_SUCCESS,
  EDIT_AD_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_ADS_SUCCESS: {
      return {
        ...state,
        ads: action.payload.ads,
      }
    }

    case GET_ADS_FAILURE: {
      return {
        ...state,
        getAdsError: action.payload.error,
      }
    }

    case GET_AD_SUCCESS: {
      return {
        ...state,
        ads: action.payload.ad,
      }
    }

    case GET_AD_FAILURE: {
      return {
        ...state,
        getAdsError: action.payload.error,
      }
    }

    case ADD_AD_SUCCESS: {
      return {
        ...state,
        ad: action.payload.ad,
      }
    }

    case ADD_AD_FAILURE: {
      return {
        ...state,
        addAdError: action.payload.error,
      }
    }

    case EDIT_AD_SUCCESS: {
      return {
        ...state,
        ad: action.payload.ad,
      }
    }

    case EDIT_AD_FAILURE: {
      return {
        ...state,
        addAdError: action.payload.error,
      }
    }

    default:
      return state
  }
}
